/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { createContext, useContext, useEffect, useReducer } from 'react';
import { initialTripsState, globalReducer, type Action, ActionType } from './global-reducer';
import { useGetOperations } from '../../hooks/queries/useGetOperations';

const GlobalContext = createContext(initialTripsState);
const GlobalDispatchContext = createContext(null);
export const GlobalContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(globalReducer, initialTripsState);
  const operations = useGetOperations();

  useEffect(() => {
    if (operations?.length) {
      dispatch({ type: ActionType.SET_OPERATIONS, payload: operations });
    }
  }, [operations]);

  return (
    <GlobalContext.Provider value={state}>
      <GlobalDispatchContext.Provider value={dispatch}> {children} </GlobalDispatchContext.Provider>
    </GlobalContext.Provider>
  );
};

export const useTripsContext = () => useContext(GlobalContext).trips;
export const useMapContext = () => useContext(GlobalContext).map;
export const useDispatch = () => useContext(GlobalDispatchContext) as React.Dispatch<Action>;
